class AplusTabbedSlider extends HTMLElement {
  constructor() {
    super();
    this.slidesContainer = this.querySelector('.aplus-tabbed-slider__slides');
    this.slides = [...this.querySelectorAll('.aplus-tabbed-slider__slide')];
    this.navBtns = [...this.querySelectorAll('.aplus-tabbed-slider__nav-btn')];
    this.prevBtn = this.querySelector('.aplus-tabbed-slider__arrow--prev');
    this.nextBtn = this.querySelector('.aplus-tabbed-slider__arrow--next');

    if (this.slides.length < 2) return;

    this.currentIndex = 0;
    this.isScrolling = false;

    // Autoplay config from data attributes
    this.autoplayEnabled = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 5000;
    this.pauseOnHover = this.dataset.pauseHover === 'true';
    this.autoplayTimer = null;
    this.isHovered = false;

    this.init();
  }

  init() {
    // Scroll listeners
    this.scrollHandler = this.debounce(this.handleScroll.bind(this), 50);
    this.slidesContainer.addEventListener('scroll', this.scrollHandler);

    // Tab buttons click listener
    this.navBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        this.handleTabClick(e);
        this.restartAutoplay();
      });
    });

    // Arrow navigation click listeners
    if (this.prevBtn && this.nextBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.navigate(-1);
        this.restartAutoplay();
      });
      this.nextBtn.addEventListener('click', () => {
        this.navigate(1);
        this.restartAutoplay();
      });
    }

    // Pause on manual touch/drag interaction, resume after
    this.slidesContainer.addEventListener('pointerdown', () => this.stopAutoplay());
    this.slidesContainer.addEventListener('pointerup', () => this.restartAutoplay());

    // Initialize state (no scroll — page hasn't loaded to this position yet)
    this.updateActiveStates(false);

    // Listen to resize to handle layouts
    window.addEventListener('on:debounced-resize', () => {
      this.updateActiveStates(false);
    });

    // Autoplay setup
    if (this.autoplayEnabled) {
      if (this.pauseOnHover) {
        this.addEventListener('mouseenter', () => {
          this.isHovered = true;
          this.stopAutoplay();
        });
        this.addEventListener('mouseleave', () => {
          this.isHovered = false;
          this.startAutoplay();
        });
      }

      // Pause autoplay when tab/window isn't visible
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          this.stopAutoplay();
        } else if (!this.isHovered) {
          this.startAutoplay();
        }
      });

this.observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // Start autoplay only when the section enters the viewport
      this.startAutoplay();
    } else {
      // Stop autoplay when the section leaves the viewport
      this.stopAutoplay();
    }
  });
}, {
  threshold: 0.6 // Start when 60% of the section is visible
});

this.observer.observe(this);  }
  }

  startAutoplay() {
    if (!this.autoplayEnabled) return;
    this.stopAutoplay();
    this.autoplayTimer = setInterval(() => {
      this.autoplayAdvance();
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
      this.autoplayTimer = null;
    }
  }

  restartAutoplay() {
    if (!this.autoplayEnabled) return;
    if (this.pauseOnHover && this.isHovered) return;
    this.startAutoplay();
  }

  autoplayAdvance() {
    const slideWidth = this.slidesContainer.clientWidth;
    if (slideWidth <= 0) return;

    const isAtEnd = this.currentIndex >= this.slides.length - 1;
    const targetIndex = isAtEnd ? 0 : this.currentIndex + 1;

    this.slidesContainer.scrollTo({
      left: targetIndex * slideWidth,
      behavior: 'smooth'
    });
  }

  handleScroll() {
    const slideWidth = this.slidesContainer.clientWidth;
    if (slideWidth <= 0) return;

    // Calculate active slide index based on scroll offset
    const scrollPos = this.slidesContainer.scrollLeft;
    const newIndex = Math.min(
        this.slides.length - 1,
        Math.max(0, Math.round(scrollPos / slideWidth))
    );
    if (newIndex !== this.currentIndex && newIndex >= 0 && newIndex < this.slides.length) {
      this.currentIndex = newIndex;
      this.updateActiveStates();
    } else {
      // Still need to update arrow disabled states if at limits
      this.updateArrowStates();
    }
  }

  handleTabClick(event) {
    const btn = event.currentTarget;
    const tabLabel = btn.dataset.tabLabel;

    // Find the first slide matching the clicked tab label
    const index = this.slides.findIndex(
      slide => slide.dataset.tabLabel === tabLabel
    );

    if (index > -1) {
      this.currentIndex = index;

      this.slidesContainer.scrollTo({
        left: index * this.slidesContainer.clientWidth,
        behavior: "smooth"
      });

      this.updateActiveStates();
    }
  }

navigate(direction) {
  let newIndex = this.currentIndex + direction;

  if (newIndex < 0) {
    newIndex = this.slides.length - 1;
  }

  if (newIndex >= this.slides.length) {
    newIndex = 0;
  }

  this.currentIndex = newIndex;

  this.slidesContainer.scrollTo({
    left: newIndex * this.slidesContainer.clientWidth,
    behavior: "smooth"
  });

  this.updateActiveStates();
}

  updateActiveStates(scrollNav = true) {
    const activeSlide = this.slides[this.currentIndex];
    if (!activeSlide) return;

    const activeLabel = activeSlide.dataset.tabLabel;

    // Update nav button active classes
    this.navBtns.forEach((btn) => {
      if (btn.dataset.tabLabel === activeLabel) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-selected', 'false');
      }
    });

    this.updateArrowStates();
    const activeBtn = this.navBtns.find(
      btn => btn.dataset.tabLabel === activeLabel
    );

   if (scrollNav && activeBtn) {
  const navWrapper = this.querySelector('.aplus-tabbed-slider__nav');
  if (navWrapper) {
    const wrapperRect = navWrapper.getBoundingClientRect();
    const btnRect = activeBtn.getBoundingClientRect();
    const scrollOffset =
      (btnRect.left + btnRect.width / 2) -
      (wrapperRect.left + wrapperRect.width / 2);

    navWrapper.scrollTo({
      left: navWrapper.scrollLeft + scrollOffset,
      behavior: 'smooth'
    });
  }
}
  }

  updateArrowStates() {
    if (!this.prevBtn || !this.nextBtn) return;

    const tolerance = 5; // Allow minor pixel variation
    const maxScroll = this.slidesContainer.scrollWidth - this.slidesContainer.clientWidth;

    this.prevBtn.disabled = this.slidesContainer.scrollLeft <= tolerance;
    this.nextBtn.disabled = this.slidesContainer.scrollLeft >= maxScroll - tolerance;
  }

  debounce(fn, wait) {
    let timeout;
    return function(...args) {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }
}

if (!customElements.get('aplus-tabbed-slider')) {
  customElements.define('aplus-tabbed-slider', AplusTabbedSlider);
}